import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { VacancyTo } from '../../../types/routes.types';
import { useI18nNavigate } from '../useI18nNavigate';

import { AutoRedirectConditionType } from './useAutoRedirect.types';

export const useAutoRedirect = (
  redirectTo: VacancyTo,
  condition: AutoRedirectConditionType
): void => {
  const { pathname } = useLocation();
  const navigate = useI18nNavigate();

  useEffect(() => {
    const redirectPath = typeof redirectTo === 'string' ? redirectTo : redirectTo.pathname;
    if (pathname !== redirectPath && condition(pathname)) {
      navigate(redirectTo);
    }
  }, [redirectTo, pathname, condition, navigate]);
};
